
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/localita-vicine",
      function () {
        return require("private-next-pages/localita-vicine.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/localita-vicine"])
      });
    }
  